import type { StudyView } from '@/models/view';
import { EmptyState } from '@/shared/ui/EmptyState';
import RecentlyViewed from '../RecentlyViewed';

interface ReaderErrorStateProps {
  recentlyViewed: StudyView[];
}

/** The reader page's `error` state (AP-778 §4): same calm canvas as the empty
 *  view — heart illustration, headline, recents to jump back into — with the
 *  error stated plainly instead of a bare alert box. The worklist rail stays
 *  alongside, so picking another study is always one click away. */
export default function ReaderErrorState({
  recentlyViewed,
}: ReaderErrorStateProps) {
  return (
    <EmptyState
      headline="This study couldn't be loaded"
      subtext="It may be unavailable right now. Pick another study from the worklist, or jump back into something recent."
    >
      <RecentlyViewed studies={recentlyViewed} />
    </EmptyState>
  );
}
